import { render, staticRenderFns } from "./dialogAddGroup.vue?vue&type=template&id=53d34300&scoped=true"
import script from "./dialogAddGroup.vue?vue&type=script&lang=js"
export * from "./dialogAddGroup.vue?vue&type=script&lang=js"
import style0 from "./dialogAddGroup.vue?vue&type=style&index=0&id=53d34300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d34300",
  null
  
)

export default component.exports